<template>
  <div class="poster">
    <div :id="image_id" class="poster-image"></div>
    <div
      class="poster-content link-content"
      v-if="poster.btn_url && (poster.btn_text || poster.text)"
    >
      <a v-if="poster.btn_text" :href="poster.btn_url" class="in-poster big">{{poster.btn_text}}</a>
      <a v-if="poster.text" :href="poster.btn_url" class="in-poster small">{{poster.text}}</a>
    </div>
    <div class="poster-content link-content" v-if="!poster.btn_url">
      <p v-if="poster.btn_text" class="in-poster big">{{poster.btn_text}}</p>
      <p v-if="poster.text" class="in-poster small">{{poster.text}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "fcwpHomePoster",
  props: ["poster"],
  computed: {
    image_id: function() {
      return "hero_img_" + this.poster.image;
    }
  }
};
</script>

<style lang="scss">
.poster {
  height: 100vh;
  margin-left: -1.17vw;
  .poster-image {
    position: absolute;
    width: 100%;
    height: 100%;
    background: no-repeat center center;
    background-size: cover;
  }

  .link-content {
    a {
      display: flex !important;
    }

    .small:before {
      content: none !important;
    }
    .small {
      position: relative;
    }

    @media (min-width: 1200px) {
      font-size: 5vw;
      .small {
        font-size: 2.5vw;
        left: 2vw;
      }
      :before {
        margin-left: 0vw;
      }
      :hover::before {
        top: -9px;
        margin-left: -3.5vw;
      }
    }
    @media (max-width: 1199px) {
      font-size: 7.5vw;
      .small {
        font-size: 3.75vw;
        left: 3vw;
      }
      :before {
        margin-left: 0vw;
      }
      :hover::before {
        margin-left: -5.25vw;
        top: -8px;
      }
    }
    @media (max-width: 768px) {
      font-size: 10vw;
      .small {
        font-size: 5vw;
        left: 4vw;
      }
      :before {
        margin-left: 0vw;
      }
      :hover::before {
        margin-left: -7vw;
        top: -7px;
      }
    }
  }

  .poster-content {
    position: absolute;
    margin: 20vh 13vw 0 13vw;
    .in-poster {
      color: rgb($septenary-color);
      display: block;
      line-height: 110%;
      text-shadow: 0 0 5px rgb($primary-color);
    }
    .big {
      text-transform: uppercase;
      margin-bottom: 10px;
    }
  }
}
</style>